<template>
  <div class="log-viewer">
    <div v-if="isBusy">
      <b-icon icon="loading" size="is-small" custom-class="mdi-spin"></b-icon>
      Loading...
    </div>
    <div v-else-if="logs.length === 0" class="no-data-error">
      <b-icon icon="google-downasaur" size="is-medium"></b-icon>
      No logs available
    </div>
    <table v-else class="logs-table">
      <tr v-for="logMsg in logs" :key="logMsg._id">
        <td class="timestamp">
          {{ formatDate(logMsg.timestamp) }}
        </td>
        <td class="msg">
          {{ logMsg.message }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import parseISO from "date-fns/parseISO"
  import format from "date-fns/format"

  export default {
    name: 'LogViewer',
    props: {
      logs: { type: Array, default: () => [] },
      isBusy: { type: Boolean, default: false }
    },
    methods: {
      formatDate (dateStr) {
        const dt = parseISO(dateStr)
        return format(dt, 'yyy-MM-dd HH:mm:ss')
      }
    }
  }
</script>

<style type="text/css">
  .log-viewer .logs-table {
    font-size: 10px;
  }
  .log-viewer .logs-table .timestamp {
    white-space: nowrap;
  }
  .no-data-error {
    opacity: .5;
  }
</style>
